import * as actionTypes from "./action_type";

const initialState = {
  pyqTestData: {},
  pyqResultData: {},
  pyqMainCurrentTab: {},
  pyqSubCurrentTab: {},
  pyqCurrentYear: null,
};

const pyqTestsReducer = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actionTypes.SET_PYQ_TESTS_DATA:
      return setPyqTestsData(state, payload);

    case actionTypes.SET_PYQ_TESTS_RESULT_DATA:
      return setPyqTestsResultData(state, payload);

    case actionTypes.SET_PYQ_MAIN_CURRENT_TAB:
      return setPyqMainCurrentTab(state, payload);

    case actionTypes.SET_PYQ_SUB_CURRENT_TAB:
      return setPyqSubCurrentTab(state, payload);

    case actionTypes.SET_PYQ_CURRENT_YEAR:
      return setPyqCurrentYear(state, payload);

    default:
      return state;
  }
};

const setPyqTestsData = (state, payload) => {
  state = { ...state, pyqTestData: payload };
  return state;
};

const setPyqTestsResultData = (state, payload) => {
  state = { ...state, pyqResultData: payload };
  return state;
};

const setPyqMainCurrentTab = (state, payload) => {
  state = { ...state, pyqMainCurrentTab: payload };
  return state;
};

const setPyqSubCurrentTab = (state, payload) => {
  state = { ...state, pyqSubCurrentTab: payload };
  return state;
};

const setPyqCurrentYear = (state, payload) => {
  state = { ...state, pyqCurrentYear: payload };
  return state;
};

export default pyqTestsReducer;
